<template>
    <div>
        <v-row>            
            <v-col sm="4">
                <br/>There are 4 types of weapons:
                <ul>
                    <li><a @click="scrollTo('augmenting')">Augmenting</a></li>
                    <li><a @click="scrollTo('light')" >Light</a></li>
                    <li><a @click="scrollTo('oneHanded')">One Handed</a></li>
                    <li><a @click="scrollTo('twoHanded')">Two Handed</a></li>
                    <li><a @click="scrollTo('primitive')">Primitive</a></li>
                    <li><a @click="scrollTo('tech')">Tech</a></li>
                    <li><a @click="scrollTo('armament')">Armaments</a></li>
                </ul>
            </v-col>
            <v-col sm="4">
                <br/>5 Rarities:
                <ul>
                    <li>Common</li>
                    <li>Rare</li>
                    <li>Epic</li>
                    <li>Legendary</li>
                    <li>Unique</li>
                </ul>
            </v-col>
        </v-row>
        <br/><br/>
        <div v-for="type in types" :key="type">
            <h2 :id="type" style="color:cornflowerblue">{{filterString(type)}} Weapons:</h2>
            <div v-for="rarity in rarities" :key="rarity">
                <h3>{{rarity[0].toUpperCase() + rarity.substr(1)}}:</h3>
                <table style="width:100%">
                    <tr> 
                        <th>Name</th>
                        <th>Damage</th>
                        <th>Crit</th>
                        <th>Range</th>
                        <th>Special</th>
                    </tr>
                    <tr v-for="weapon in sortedWeapons(type, rarity)" :key="weapon.name"> 
                        <td style="text-align:center">{{weapon.name}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{weapon.damage}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{weapon.crit}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{weapon.range}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{weapon.special}}</td>
                    </tr>
                </table>           
                <br/>
        </div> 
    </div>
    </div>
</template>
<script>
//
import {weapons} from "../../../play/data"

export default {
  components: {
  },
  props:{
  },
  mounted(){
  },
  data(){
      return{
          types:['augmenting','light', 'oneHanded', 'twoHanded', 'primitive', 'tech','armament'],
          rarities:["common","rare","epic","legendary","unique"],
      }
  },
  methods:{
      sortedWeapons(type,rarity){
        let allWeapons = [...weapons]
        let sortedWeapons = allWeapons.filter(weapon=>weapon.type == type && weapon.rarity == rarity)        
        let sorted = sortedWeapons.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        sorted = sorted.filter((value, index, self) =>
        index === self.findIndex((t) => (t.name === value.name)))
        return sorted
      },
      scrollTo(id){
        let section = document.getElementById(id)
        section.scrollIntoView({behavior: "smooth"})
      },    
      filterString(str){
          let remove = str.replace("Handed"," Handed")
          let newStr = remove[0].toUpperCase() + remove.substring(1)
          return newStr

      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>